export const CRM_PAGE_EDITOR_ADMIN = 'crm-page-editor-admin';
export const CRM_CATCH_UP_FULL_ACCESS = 'crm-catch-up-full-access';